// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//使用element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookies from 'vue-cookies'
//导入全局样式
import './assets/global-style.css'
import globalp from  './components/Global'
import './assets/global_js'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.prototype.GLOBAL  = globalp

//ztree树引入
import './assets/ztree/jquery.ztree.core'
import './assets/ztree/jquery.ztree.excheck.min'
import './assets/ztree/jquery.ztree.exhide'

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js